<template>
	<div class="elapsed-timer">
		<div
			v-once
			class="flex-child title"
		>
			Elapsed
		</div>
		<div class="flex-child time">{{ time }}</div>
		<div
			v-once
			class="flex-child controls"
		>
			<BaseButton @click="timer.start">Start</BaseButton>
			<BaseButton @click="timer.stop">Pause</BaseButton>
			<BaseButton @click="timer.reset">Reset</BaseButton>
		</div>
	</div>
</template>

<script>
import formatTime from '@/utils/formatTime';
import BaseButton from './BaseButton.vue';
import createTimer from './Timer';

export default {
	name: 'ElapsedTimer',
	components: {
		BaseButton,
	},
	data() {
		return {
			timer: createTimer({ ms: false, onTick: this.tick.bind(this) }),
			elapsed: 0,
		};
	},
	computed: {
		time() {
			return formatTime(this.elapsed);
		},
	},
	mounted() {
		this.timer.start();
	},
	beforeDestroy() {
		this.timer.stop();
	},
	methods: {
		tick(elapsed) {
			this.elapsed = elapsed;
		},
	},
};
</script>

<style lang="stylus" scoped>
@require '../sizes'

.elapsed-timer
	grid-area elapsed
	display flex
	align-items center
	justify-content flex-start
	flex-flow column

	> .title
		font-size 1.2rem

	> .flex-child:not(:last-child)
		margin-bottom size-half
</style>



// WEBPACK FOOTER //
// src/components/ElapsedTimer.vue